import * as React from "react";
function SvgIcMinus(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M5 12h14.266v.75H5V12z" fill="currentColor" />
    </svg>
  );
}
export default SvgIcMinus;
